import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';

// Sale del calendario de zonas (25/26-oct-2026); desde el 27-oct-2026 vive en la vista Agenda de Trabajos.
// Sugerirle otro día a la empresa (26-oct-2026): la empresa decide; si no responde antes del cierre, vale lo suyo
export default function SugerirDia({ p, dias, onListo }) {
    const [abierto, setAbierto] = useState(false);
    const [fecha, setFecha] = useState(null);
    const [nota, setNota] = useState('');
    const [enviando, setEnviando] = useState(false);
    const enviar = async (f) => {
        setEnviando(true);
        try {
            await api.post('/mapa/semana/sugerir', { pedidoId: p.pedidoId, fecha: f, nota: f ? nota : undefined });
            toast.success(f ? 'Sugerencia enviada a la empresa' : 'Sugerencia retirada');
            setAbierto(false); setFecha(null); setNota('');
            onListo();
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo enviar'); }
        finally { setEnviando(false); }
    };
    if (p.sugerencia) {
        return (
            <p className="mt-1 text-label text-[#0284C7] dark:text-[#38BDF8] font-bold">
                Sugeriste el {p.sugerencia.dia} · esperando respuesta{' '}
                <button type="button" disabled={enviando} onClick={() => enviar(null)} className="underline text-secondary">Retirar</button>
            </p>
        );
    }
    if (!abierto) return <button type="button" onClick={() => setAbierto(true)} className="mt-1 text-label font-black text-secondary underline">{p.rutaFecha ? 'Sugerir otro día' : 'Sugerir un día'}</button>;
    const opciones = dias.filter(d => d.trabaja && !d.cerrado && d.fecha !== p.rutaFecha && d.fecha > hoyISO());
    return (
        <div className="mt-1.5 space-y-1.5">
            <div className="flex gap-1 overflow-x-auto">
                {opciones.map(d => (
                    <button key={d.fecha} type="button" onClick={() => setFecha(d.fecha)} aria-pressed={fecha === d.fecha}
                        className={`h-8 px-2 shrink-0 rounded-lg text-label font-black capitalize ${fecha === d.fecha ? 'bg-ink text-page' : 'bg-chip text-secondary'}`}>{d.dia.split(' ').slice(0, 2).join(' ')}</button>
                ))}
            </div>
            <div className="flex gap-1.5">
                <input value={nota} onChange={e => setNota(e.target.value)} maxLength={300} placeholder="Por qué (opcional): queda al lado de otro"
                    className="flex-1 min-w-0 h-9 px-2.5 rounded-lg bg-card text-ink text-caption outline-none placeholder:text-muted" />
                <button type="button" disabled={!fecha || enviando} onClick={() => enviar(fecha)} className="h-9 px-3 rounded-lg bg-[#0284C7] text-white text-label font-black disabled:opacity-40">Enviar</button>
                <button type="button" onClick={() => setAbierto(false)} className="h-9 px-2 rounded-lg text-label font-black text-secondary">Cancelar</button>
            </div>
        </div>
    );
}
const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };

